module.exports = __webpack_public_path__ + "static/img/customer-02-big.55c6d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/customer-02-big.png
// module id = onvS
// module chunks = 2